import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-wrenches',
  templateUrl: './loading-wrenches.component.html',
  styleUrls: ['./loading-wrenches.component.scss'],
})
export class LoadingWrenchesComponent {}
